import {
  SET_TRATAMIENTO,
  SET_SEXO,
  SET_NOMBRE_CAMPAIGN,
  SET_APELLIDO_MATERNO_CAMPAIGN,
  SET_APELIIDO_PATERNO_CAMPAIGN,
  SET_ESTADO_CAMPAIGN,
  SET_CIUDAD_CAMPAIGN,
  SET_ID_CONCESIONARIO_CAMPAIGN,
  SET_CONCESIONARIO_CAMPAIGN,
  SET_TELEFONO_CAMPAIGN,
  SET_MOVIL_CAMPAIGN,
  SET_CORREO_CAMPAIGN,
  SET_COMENTARIOS_CAMPAIGN,
  SET_AVISO_PRIVACIDAD_CAMPAIGN,
  SET_TERMINOS_Y_CONDICIONES_CAMPAIGN,
  SET_TRANSFERENCIA_DE_DATOS_CAMPAIGN,
  SET_CONTACO_MARKETING_CAMPAIGN,
  SET_VEIHICULO_CAMPAIGN,
  SET_TIPO_CITA_CAMPAIGN,
  RESET_STATE_CAMPAIGN,
} from "../types";

const initialState = {
  fuenteSitioWeb: "Sitio Web Audi",
  marca: "Audi",
  tipoRegistro: "",
  fuenteSecundaria: "",
  tercerNivel: "",
  llaveOrigen: "",
  tratamiento: "Sr",
  sexo: "Masculino",
  nombre: "",
  apellidoMaterno: "",
  apellidoPaterno: "",
  telefono: "",
  celular: "",
  email: "",
  ciudad: "",
  provincia: "",
  concesionariaPreferida: "",
  vehiculoActual: "",
  descripcion: "",
  permisoTransferenciaDatos: false,
  permisoContactoMarketing: false,
  urlWeb: "",
  tipoCita: "Form Campaña Ducatti",
  fechaNacimiento: "",
  numeroConcesionaria: "",
  horarioPreferente: "",
  fechaPreferente: "",
  vehiculoInteres: "",
  urlPrivacidad: "",
  status: "",
  fbCampaignID: "",
  avisoPrivacidad: false,
  terminosCondiciones: false,
  nombreDelVehiculo: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TRATAMIENTO:
      return {
        ...state,
        tratamiento: action.payload,
      };
    case SET_SEXO:
      return {
        ...state,
        sexo: action.payload,
      };
    case SET_NOMBRE_CAMPAIGN:
      return {
        ...state,
        nombre: action.payload,
      };
    case SET_APELLIDO_MATERNO_CAMPAIGN:
      return {
        ...state,
        apellidoMaterno: action.payload,
      };
    case SET_APELIIDO_PATERNO_CAMPAIGN:
      return {
        ...state,
        apellidoPaterno: action.payload,
      };
    case SET_ESTADO_CAMPAIGN:
      return {
        ...state,
        provincia: action.payload,
      };
    case SET_CIUDAD_CAMPAIGN:
      return {
        ...state,
        ciudad: action.payload,
      };
    case SET_ID_CONCESIONARIO_CAMPAIGN:
      return {
        ...state,
        numeroConcesionaria: action.payload,
      };
    case SET_CONCESIONARIO_CAMPAIGN:
      return {
        ...state,
        concesionariaPreferida: action.payload,
      };
    case SET_TELEFONO_CAMPAIGN:
      return {
        ...state,
        telefono: action.payload,
      };
    case SET_MOVIL_CAMPAIGN:
      return {
        ...state,
        celular: action.payload,
      };
    case SET_CORREO_CAMPAIGN:
      return {
        ...state,
        email: action.payload,
      };
    case SET_COMENTARIOS_CAMPAIGN:
      return {
        ...state,
        descripcion: action.payload,
      };
    case SET_AVISO_PRIVACIDAD_CAMPAIGN:
      return {
        ...state,
        avisoPrivacidad: action.payload,
      };
    case SET_TERMINOS_Y_CONDICIONES_CAMPAIGN:
      return {
        ...state,
        terminosCondiciones: action.payload,
      };
    case SET_TRANSFERENCIA_DE_DATOS_CAMPAIGN:
      return {
        ...state,
        permisoTransferenciaDatos: action.payload,
      };
    case SET_CONTACO_MARKETING_CAMPAIGN:
      return {
        ...state,
        permisoContactoMarketing: action.payload,
      };
    case SET_VEIHICULO_CAMPAIGN:
      return {
        ...state,
        vehiculoInteres: action.payload,
      };
    case SET_TIPO_CITA_CAMPAIGN:
      return {
        ...state,
        tipoCita: action.payload,
      };
    case RESET_STATE_CAMPAIGN:
      return initialState;
    default:
      return state;
  }
}
